<template>
  <v-dialog
    v-model="isActive"
    v-bind="$attrs"
    @keydown.esc="onCancel"
    @click:outside="onCancel"
  >
    <v-card>
      <!-- TODO: add images for different error types -->
      <img
        v-if="noImage"
        class="dialog__image pa-4 pb-0"
        src="@/assets/images/dialog_warning_icon.svg"
      />
      <v-card-title class="text-h6 primary--text justify-center">
        {{ localTitle }}
      </v-card-title>
      <v-card-text class="pt-4">
        <AlertList
          v-if="localErrors && localErrors.length > 0"
          :alerts="localErrors"
          :alert-type="localErrorType"
          class="mb-4"
        />
        <!-- This slot generally contains a question (eventaully an associated action) -->
        <slot>
          <p class="text-body-1">{{ localMessage }}</p>
        </slot>
      </v-card-text>
      <v-card-actions>
        <BaseDialogActions
          v-bind="baseActionProps"
          @cancel="onCancel"
          @continue="onContinue"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AlertList from './AlertList.vue';

export default {
  // Use props to set defaults for title/messages/errors, in case you re-use the dialog in the same component.
  // Use a ref to call the show method with temporary settings (https://vuejs.org/v2/guide/components-edge-cases.html#Accessing-Child-Component-Instances-amp-Child-Elements)
  components: { AlertList },
  props: {
    baseActionProps: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    errors: {
      // Show list of provided errors in an AlertList
      type: Array,
      default: () => [],
    },
    errorType: {
      type: String,
      default: 'error',
      validator: v => ['warning', 'error', 'info', 'success'].includes(v),
    },
    autoResolve: {
      // if no errors, automatically resolve and skip dialog
      type: Boolean,
      default: false,
    },
    noImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      tempTitle: '',
      tempMessage: '',
      tempErrors: null,
      tempErrorType: null,
      // Private
      resolve: null,
      reject: null,
    };
  },
  computed: {
    localTitle() {
      return (
        this.tempTitle || this.title || this.$t('general.phrases.attention')
      );
    },
    localMessage() {
      return this.tempMessage || this.message;
    },
    localErrors() {
      return this.tempErrors || this.errors || [];
    },
    localErrorType() {
      return this.tempErrorType || this.errorType;
    },
  },
  methods: {
    show(opts) {
      // Use opts to add props programmatically (e.g. errors in a function)
      this.tempTitle = opts?.title;
      this.tempMessage = opts?.message;
      this.tempErrors = opts?.errors;
      this.tempErrorType = opts?.errorType; // REFACTOR: filter errors by error type into different alertList components

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;

        if (
          this.autoResolve &&
          (!this.localErrors || this.localErrors.length < 1)
        ) {
          this.onContinue();
          return;
        }

        this.isActive = true;
      });
    },
    onContinue() {
      // this.isActive = false;
      this.resolve(true);
      this.reset();
    },
    onCancel() {
      // this.isActive = false;
      this.reject('Prompt canceled!');
      this.reset();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog__image {
  position: relative;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
}
</style>
